export class AppJumpXiaoyuUtil {
  static readonly config = {
    user: {
      android: {
        page: 'user_info_dialog',
        params: {},
      },
      ios: {
        page: 'UserViewController',
        params: {
          showUserInfo: true,
        },
      },
    },

    dictationRecords: {
      android: {
        page: 'record_list',
        params: {},
      },
      ios: {
        page: 'DictationRecordListViewController',
        params: {},
      },
    },
  }
}
